import React from 'react';

import { ReactComponent as RecordedMusic } from 'icons/divisions/recorded-music.svg';
import { ReactComponent as Corporate } from 'icons/divisions/corporate.svg';
import { ReactComponent as Publishing } from 'icons/divisions/publishing.svg';

export default (): any => [
  { label: 'Recorded Music', value: 'recordedMusic', icon: <RecordedMusic /> },
  { label: 'Corporate', value: 'corporate', icon: <Corporate /> },
  { label: 'Publishing', value: 'publishing', icon: <Publishing /> },
];
